// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
.country-selector {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.country-selector__button {
  display: flex;
  align-items: center;
  gap: 7px;
  background: transparent;
  border: none;
  color: #ffedd6;
  font-weight: 700;
  font-size: 14.4px;
  cursor: pointer;
  padding: 0;
  transition: opacity 0.2s ease;
}
.country-selector__button:hover {
  opacity: 0.85;
}
.country-selector__button:focus-visible {
  outline: 2px solid white;
  outline-offset: 2px;
  border-radius: 2px;
}
.country-selector__flag {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.country-selector__label {
  white-space: nowrap;
}
.country-selector__dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: white;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
  z-index: 1000;
}
.country-selector__option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  background: transparent;
  border: none;
  color: #3d051f;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  text-align: left;
  transition: background-color 0.2s ease;
}
.country-selector__option:hover {
  background-color: rgba(61, 5, 31, 0.05);
}
.country-selector__option:focus-visible {
  outline: 2px solid #3d051f;
  outline-offset: -2px;
}
.country-selector__option:first-child {
  border-radius: 4px 4px 0 0;
}
.country-selector__option:last-child {
  border-radius: 0 0 4px 4px;
}
.country-selector:hover .country-selector__dropdown {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/layout/components/atoms/country-selector/country-selector.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACEA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,6BAAA;AAAJ;AAEI;EACE,aAAA;AAAN;AAGI;EACE,wBAAA;EACA,mBAAA;EACA,kBAAA;AADN;AAKE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;EACA,mEAAA;EACA,aAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,cD3DY;EC4DZ,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,sCAAA;AANJ;AAQI;EACE,uCAAA;AANN;AASI;EACE,0BAAA;EACA,oBAAA;AAPN;AAUI;EACE,0BAAA;AARN;AAWI;EACE,0BAAA;AATN;AAcE;EACE,UAAA;EACA,mBAAA;EACA,wBAAA;AAZJ","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n\n.country-selector {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n\n  &__button {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    background: transparent;\n    border: none;\n    color: #ffedd6;\n    font-weight: 700;\n    font-size: 14.4px;\n    cursor: pointer;\n    padding: 0;\n    transition: opacity 0.2s ease;\n\n    &:hover {\n      opacity: 0.85;\n    }\n\n    &:focus-visible {\n      outline: 2px solid white;\n      outline-offset: 2px;\n      border-radius: 2px;\n    }\n  }\n\n  &__flag {\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    object-fit: cover;\n    flex-shrink: 0;\n  }\n\n  &__label {\n    white-space: nowrap;\n  }\n\n  &__dropdown {\n    position: absolute;\n    top: calc(100% + 8px);\n    right: 0;\n    background: white;\n    border-radius: 4px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    min-width: 180px;\n    opacity: 0;\n    visibility: hidden;\n    transform: translateY(-8px);\n    transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;\n    z-index: 1000;\n  }\n\n  &__option {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 12px 16px;\n    background: transparent;\n    border: none;\n    color: $wine-red-dark;\n    font-weight: 600;\n    font-size: 0.9rem;\n    cursor: pointer;\n    text-align: left;\n    transition: background-color 0.2s ease;\n\n    &:hover {\n      background-color: rgba($wine-red-dark, 0.05);\n    }\n\n    &:focus-visible {\n      outline: 2px solid $wine-red-dark;\n      outline-offset: -2px;\n    }\n\n    &:first-child {\n      border-radius: 4px 4px 0 0;\n    }\n\n    &:last-child {\n      border-radius: 0 0 4px 4px;\n    }\n  }\n\n  // Show dropdown on hover\n  &:hover &__dropdown {\n    opacity: 1;\n    visibility: visible;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
